import { LoginResponse } from '../../../oidc/oidc-security.service';

export class AuthentificationResponse {
  failed: boolean;
  loginResponse: LoginResponse;

  constructor(failed: boolean, loginResponse: LoginResponse) {
    this.failed = failed;
    this.loginResponse = loginResponse;
  }

  public hasFailed(): boolean {
    return this.failed;
  }

  static success(loginResponse: LoginResponse): AuthentificationResponse {
    return new AuthentificationResponse(false, loginResponse);
  }

  static failure(): AuthentificationResponse {
    return new AuthentificationResponse(true, null);
  }
}
